import { gql } from "@apollo/client";

import {
  CompanyFilter,
  CompanyMatchFilter,
} from "../../legacy/types/companyFilter";

export interface InstallDetection {
  productId: number;
  companyCount: number;
  marketCount: number;
  monthStartDate: string;
}

export interface QueryPayload {
  marketPenetrationOverTime: InstallDetection[];
}

export interface QueryVariables {
  companyFilters: CompanyFilter;
  productIds: number[];
  localizeInstalls?: boolean;
  lookbackYears?: number;
  companyMatchFile?: CompanyMatchFilter;
}

export const MARKET_PENETRATION_OVER_TIME = gql`
  query marketPenetrationOverTime(
    $companyFilters: CompanyFilter!
    $productIds: [Int]!
    $localizeInstalls: Boolean
    $lookbackYears: Int!
    $companyMatchFile: CompanyMatchFilter
  ) {
    marketPenetrationOverTime(
      companyFilters: $companyFilters
      productIds: $productIds
      localizeInstalls: $localizeInstalls
      lookbackYears: $lookbackYears
      companyMatchFile: $companyMatchFile
    ) {
      productId
      companyCount
      marketCount
      monthStartDate
    }
  }
`;
